module.exports = __webpack_public_path__ + "static/media/beyond-travel-circle.78b884ad.png";